import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import useStaxAPI from "Payments/AddPaymentMethod/CreditCardEntry/useStaxAPI";

import usePaymentMethodState from "../paymentMethodState";
import { useACHIsEditing } from "../paymentMethodStateHooks";

import ACHFields from "./ACHFields";
import useStaxACHValidations from "./useStaxACHValidations";

export default function StaxACHEntry({
  cardType,
  handleEditButtonClick,
  last4,
  setInputErrors,
  getPaymentMethodTokenTrigger, // submitting
  setPaymentMethodTokenInfo,
}) {
  const { shouldRetokenize, nickname, name, ach, paymentMethodID, setState } =
    usePaymentMethodState();
  const [isEditing] = useACHIsEditing();
  // const [userData] = useUserData();

  const [validationIsReady, setValidationIsReady] = useState(false);
  const { tokenize, loadStaxJs, initializeStaxACHForm } = useStaxAPI();

  let staxIsLoaded;
  if (!staxIsLoaded) {
    staxIsLoaded = loadStaxJs();
  }

  useEffect(() => {
    if (
      getPaymentMethodTokenTrigger &&
      (shouldRetokenize || !paymentMethodID)
    ) {
      setValidationIsReady(true);
    }
  }, [getPaymentMethodTokenTrigger, shouldRetokenize, paymentMethodID]);

  const clearValidationFlags = () => {
    setValidationIsReady(false);
    setInputErrors([]);
  };

  const onSuccessfulTokenization = (res) => {
    // console.log("SUCCESS");
    const pmTokenInfo = { ...res, nickname };
    setPaymentMethodTokenInfo(pmTokenInfo);
    clearValidationFlags();
  };

  const onFailedTokenization = (errors) => {
    console.log("FAILED FAILED FAILED FAILED", errors);
    setValidationIsReady(false);
    setPaymentMethodTokenInfo({ error: true });
    setState({ submitting: false });
    setInputErrors(errors);
  };

  useStaxACHValidations({
    data: { ach },
    isReady: validationIsReady,
    onSuccess: () => {
      tokenize({
        extraDetails: {
          method: "bank",
          bank_type: ach.accountType,
          bank_holder_type: ach.accountHolderType,
          bank_account: ach.accountNumber,
          bank_routing: ach.routingNumber,
          person_name: name.trim(),
          // address_1: userData?.addressInfo?.address1 || undefined,
          // address_2: userData?.addressInfo?.address2 || undefined,
          // address_city: userData?.addressInfo?.city || undefined,
          // address_state: userData?.addressInfo?.state || undefined,
          // address_zip: userData?.addressInfo?.zip || undefined,
          // phone: userData?.phoneInfo?.phone || undefined,
          // email: userData?.emailInfo?.email || undefined,
        },
        onSuccess: onSuccessfulTokenization,
        onFailure: onFailedTokenization,
      });
    },
    onFailure: (errors) => {
      onFailedTokenization(errors);
    },
  });

  useEffect(
    function initStaxForm() {
      // if (staxIsLoaded) return;

      if (isEditing) {
        initializeStaxACHForm();
      }
    },
    [staxIsLoaded, isEditing, initializeStaxACHForm]
  );

  return <ACHFields cardType={cardType} />;
}

StaxACHEntry.propTypes = {
  cardType: PropTypes.string,
  handleEditButtonClick: PropTypes.func,
  last4: PropTypes.string,
  setInputErrors: PropTypes.func,
  getPaymentMethodTokenTrigger: PropTypes.bool,
  setPaymentMethodTokenInfo: PropTypes.func,
};
